import React from 'react';

export default function SectionHeader({ title, actions }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
      {actions && <div className="space-x-2">{actions}</div>}
    </div>
  );
}
